import { ApplicationStatus } from "../interfaces/enums";

/**
 * Utility functions dla tłumaczenia statusów zgłoszeń
 *
 * Ten plik zawiera funkcje tłumaczenia:
 * - Statusów zgłoszeń na polskie teksty
 * - Różne formaty wyświetlania statusów
 * - Krótkie i długie wersje tekstów
 */

// ============================================================================
// TŁUMACZENIA STATUSÓW ZGŁOSZEŃ
// ============================================================================

/**
 * Tłumaczy status zgłoszenia na polski tekst (pełny)
 */
export const getStatusLabel = (status: ApplicationStatus): string => {
  switch (status) {
    case ApplicationStatus.DRAFT:
      return "W PRZYGOTOWANIU";
    case ApplicationStatus.SENT:
      return "WYSŁANE";
    case ApplicationStatus.APPROVED:
      return "ZATWIERDZONE";
    case ApplicationStatus.REJECTED:
      return "ODRZUCONE";
    case ApplicationStatus.CANCELED:
      return "ANULOWANE";
    case ApplicationStatus.MODERATION:
      return "W MODERACJI";
    default:
      return "NIEZNANY";
  }
};

// ============================================================================
// FUNKCJE POMOCNICZE
// ============================================================================

/**
 * Sprawdza czy status jest finalny (nie można go zmienić)
 */
export const isFinalStatus = (status: ApplicationStatus): boolean => {
  return status === ApplicationStatus.APPROVED || status === ApplicationStatus.REJECTED;
};

/**
 * Sprawdza czy status można edytować
 */
export const isEditableStatus = (status: ApplicationStatus): boolean => {
  return status === ApplicationStatus.DRAFT || status === ApplicationStatus.MODERATION;
};

/**
 * Sprawdza czy status można wysłać
 */
export const canSendStatus = (status: ApplicationStatus): boolean => {
  return status === ApplicationStatus.DRAFT;
};

/**
 * Sprawdza czy status można anulować
 */
export const canCancelStatus = (status: ApplicationStatus): boolean => {
  return status === ApplicationStatus.SENT || status === ApplicationStatus.MODERATION;
};
